"use strict";

var agendorAPI = require("app/util/api/agendor-api");
var phpAPI = require("app/util/api/php-api");

var TYPES = {
  "organization": "Empresa",
  "person": "Pessoa",
  "deal": "Negocio"
};

module.exports.get = function get(params, callback) {
  if (window && window.loggedUserFeatures.newSearch) {
    agendorAPI.get("/internal/search", params, callback);
  } else {
    var notObj = Object.keys(TYPES)
      .filter(type => !params.types.includes(type))
      .map(type => TYPES[type])
      .join("-");

    phpAPI.searchEntity({
      q: params.q,
      qpp: params.per_page,
      pg: params.page,
      notObj: notObj
    }, callback);
  }
};



// WEBPACK FOOTER //
// ./app/util/api/search.js